// extracted by mini-css-extract-plugin
export default {"ConnectWallet":"ConnectWallet_ConnectWallet__p5btm"};